// ── 테넌트 브랜딩 편집 (회사명 + 로고) ────────────────────────────────────────
// 저장한 회사명(display_name)·로고(logo_url, base64 data URI)가 해당 테넌트 관리자
// 화면 좌상단에 반영된다(/api/me → SidebarHeader). 로고는 서버(saas_tenants)에 저장.

import React, { useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { input, btn, btnOutline } from './saasShared';

const MAX_LOGO_BYTES = 200 * 1024; // 200KB
const ACCEPT = 'image/png,image/jpeg,image/svg+xml';
const ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml'];

export default function TenantBrandingPanel({ tenant, showToast, onSaved }) {
  const [displayName, setDisplayName] = useState(tenant.display_name || '');
  const [logo, setLogo] = useState(tenant.logo_url || ''); // data URI 또는 경로
  const [saving, setSaving] = useState(false);

  function onPickFile(e) {
    const f = e.target.files?.[0];
    e.target.value = '';
    if (!f) return;
    if (!ALLOWED_TYPES.includes(f.type)) { showToast('PNG·JPG·SVG 이미지만 올릴 수 있습니다.', 'error'); return; }
    if (f.size > MAX_LOGO_BYTES) { showToast('로고는 200KB 이하 이미지만 가능합니다.', 'error'); return; }
    const reader = new FileReader();
    reader.onload = () => setLogo(String(reader.result || ''));
    reader.onerror = () => showToast('이미지를 읽지 못했습니다.', 'error');
    reader.readAsDataURL(f);
  }

  async function save() {
    setSaving(true);
    const res = await apiClient.put(`/api/admin/saas/tenants/${tenant.code}`, {
      display_name: displayName.trim(),
      logo_url: logo || '',
    });
    setSaving(false);
    if (!res.ok || !res.data?.success) { showToast(res.data?.message || '저장 실패', 'error'); return; }
    showToast('브랜딩을 저장했습니다. (해당 테넌트 관리자 화면 좌상단에 반영)', 'success');
    onSaved?.();
  }

  const initial = String(displayName || tenant.name || '?').trim().charAt(0) || '?';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 560 }}>
      <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>
        이 테넌트 관리자 화면 <strong>좌상단</strong>에 표시될 회사명과 로고입니다.
      </div>
      <label style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
        회사명(화면 표시)
        <input
          style={{ ...input, flex: 1 }}
          value={displayName}
          placeholder="예: (주)홍길동상사"
          onChange={(e) => setDisplayName(e.target.value)}
        />
      </label>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ width: 56, height: 56, borderRadius: 10, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', border: '1px solid var(--border)', flexShrink: 0 }}>
          {logo
            ? <img src={logo} alt="로고 미리보기" style={{ width: 44, height: 44, objectFit: 'contain' }} />
            : <span style={{ fontWeight: 800, color: '#0f766e', fontSize: 22 }}>{initial}</span>}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
          <div style={{ display: 'flex', gap: 6 }}>
            <label style={{ ...btnOutline, cursor: 'pointer', margin: 0 }}>
              로고 업로드
              <input type="file" accept={ACCEPT} style={{ display: 'none' }} onChange={onPickFile} />
            </label>
            {logo && <button style={btnOutline} onClick={() => setLogo('')}>로고 제거</button>}
          </div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', lineHeight: 1.5 }}>
            PNG · JPG · SVG · 정사각형 권장(1:1) · 권장 256×256px · 최대 200KB
          </div>
        </div>
      </div>
      <div><button style={btn} onClick={save} disabled={saving}>{saving ? '저장 중...' : '브랜딩 저장'}</button></div>
    </div>
  );
}
